// «Фільтр інгредієнтів», як у застосунку (екран Filter): піца підходить, коли в її складі є все вибране.
// Склад беремо з опису піци через кому — так само робить бекенд для застосунку (ProductController::pizzasIngredients),
// тож окремий запит не потрібен. У фільтрі лише інгредієнти з розділів нижче: орегано, кунжут, тісто й нові,
// яких тут немає, не показуються (власник 04.11: «Інше» не давати). icon — ключ ICONS (v2icons.js) біля назви розділу

export const INGREDIENT_GROUPS = [
    { key: 'meat', icon: 'drumstick', name: "М'ясне", terms: ['шинка', 'курка', 'бекон', 'салямі', 'мисливські ковбаски', 'пепероні', 'ковбаса чорізо'] },
    { key: 'sea', icon: 'shrimp', name: 'Морепродукти', terms: ['тунець', 'креветки', 'мідії', 'кальмар'] },
    { key: 'cheese', icon: 'cheese', name: 'Сири', terms: ['сир', 'моцарела', 'салатна моцарела', 'пармезан', 'дорблю', 'фета', 'емменталь', 'камамбер', 'чеддер'] },
    { key: 'veg', icon: 'carrot', name: 'Овочі, гриби, фрукти', terms: ['печериці', 'печериці в карі', 'цибуля', 'синя цибуля', 'зелена цибуля', 'перець', 'гострий перець', 'помідори чері', "в'ялені томати", 'кукурудза', 'броколі', 'рукола', 'маслини', 'корнішони', 'огірки', 'ананаси', 'груша', 'лимон', 'часник', 'зелень', 'петрушка'] },
    { key: 'sauce', icon: 'droplet', name: 'Соуси', terms: ['томатний соус', 'вершки', 'вершки після печі', 'вершково-шпинатний соус', 'соус барбекю', 'соус теріякі', 'песто', 'гострий пірі-пірі'] }
];

const norm = text => String(text || '').trim().toLowerCase().replace(/ʼ|’/g, "'");

// Інгредієнти піци — частини опису через кому
export function pizzaTerms(product) {
    return String(product.description || '').split(',').map(norm).filter(Boolean);
}

export function hasAll(product, selected) {
    if (!selected.length) return true;
    const terms = pizzaTerms(product);
    return selected.every(term => terms.includes(term));
}

// «піца / піци / піц» для лічильників
export function pizzasWord(count) {
    const n = Math.abs(count) % 100, d = n % 10;
    if (n > 10 && n < 20) return 'піц';
    if (d == 1) return 'піца';
    if (d >= 2 && d <= 4) return 'піци';
    return 'піц';
}

export function termLabel(term) {
    return term.charAt(0).toUpperCase() + term.slice(1);
}
